"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publish = publish;
exports.tempFilesWatcher = tempFilesWatcher;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _helpers = require("@qwkin/helpers");
var _variables = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables2 = require("../variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(tempFilesWatcher);
function publish(_ref) {
  var payload = _ref.payload,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _response$data$tempFi, _response$data, response, _err$response, _err$response2;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.TempFilesService.publish, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables2.PUBLISH_TEMP_FILE_SUCCESS,
            payload: response
          });
        case 6:
          callback((_response$data$tempFi = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.tempFiles) !== null && _response$data$tempFi !== void 0 ? _response$data$tempFi : []);
          _context.next = 17;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          console.log(_context.t0);
          _context.next = 14;
          return (0, _effects.put)({
            type: _variables2.PUBLISH_TEMP_FILE_FAIL,
            payload: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response
          });
        case 14:
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)(_context.t0 === null || _context.t0 === void 0 || (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data)
            }
          });
        case 16:
          (0, _utils.logErr)(_context.t0 === null || _context.t0 === void 0 || (_err$response2 = _context.t0.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  })();
}
function tempFilesWatcher() {
  return _regenerator["default"].wrap(function tempFilesWatcher$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables2.PUBLISH_TEMP_FILE_REQUEST, publish)]);
      case 2:
      case "end":
        return _context2.stop();
    }
  }, _marked);
}